import React, {
  useRef, useState, useEffect,
} from 'react';
import clsx from 'clsx';
import Button, { ButtonType } from '../Button/Button';
import { useIsActiveMenuItem } from './useActiveMenuItem';
import Menu from './Menu';
import styles from './Navigation.module.scss';
import { INavigationItem } from './Navigation.type';

interface NavigationItemMobileProps {
  item: INavigationItem;
  isSubmenuOpen: boolean;
  toggleMenu: () => void;
  closeMenu?: () => void;
}

const NavigationItemMobile: React.FC<NavigationItemMobileProps> = ({
  item, closeMenu, isSubmenuOpen, toggleMenu,
}) => {
  const [height, setHeight] = useState(0);
  const submenuRef = useRef<HTMLDivElement>(null);
  const isActive = useIsActiveMenuItem(item.link, true);
  const hasSubmenu = item.menu && item.menu.length > 0;

  useEffect(() => {
    if (submenuRef.current) {
      setHeight(isSubmenuOpen ? submenuRef.current.scrollHeight : 0);
    }
  }, [isSubmenuOpen]);

  const handleClick = () => {
    if (hasSubmenu) {
      toggleMenu();
    } else {
      closeMenu?.();
    }
  };

  return (
    <div className={styles.mobileNavItem}>
      <Button
        type={ButtonType.TEXT_DARK}
        className={clsx(styles.categoryLink, {
          [styles.active]: isActive,
          [styles.hasSubmenu]: hasSubmenu,
        })}
        href={!hasSubmenu ? item.link : undefined}
        onClick={handleClick}
        iconName={hasSubmenu ? (isSubmenuOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down') : ''}
        iconSize={24}
        iconClassName={styles.dropdownIcon}
      >
        {item.title}
      </Button>

      {item.menu && item.menu.length > 0 && (
        <div
          ref={submenuRef}
          className={clsx(styles.dropdownWrapper, {
            [styles.open]: isSubmenuOpen,
          })}
          style={{
            maxHeight: `${height}px`,
          }}
        >
          <Menu
            menu={item.menu}
            onClick={closeMenu}
            isOpen={isSubmenuOpen}
          />
        </div>
      )}
    </div>
  );
};

export default NavigationItemMobile;
